import { z } from "zod";

const zActionSchema = z.enum(["CREATE", "UPDATE", "DELETE", "UNKNOWN"]);
const ActionSchema = zActionSchema.Enum;
type ActionSchema = z.infer<typeof zActionSchema>;

export { ActionSchema as Action, ActionSchema, zActionSchema };
